<!--我的举报记录-->
<template>
  <div id="reportRecord" class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{logintype=='SHOP'||logintype=='DEALER'?"违规举报":'违规处理'}}</el-breadcrumb-item>
      <el-breadcrumb-item>我的举报记录</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <!--查询-->
      <headerSearch
        @searchTable="searchTable"
        :dealState="dealState"
        :productShow="false"
        :fullStatus="true"
      ></headerSearch>
    </section>
    <section class="content-warpper" style="min-height: 631px">
      <div class="common_table">
        <el-table
          ref="multipleTable"
          header-row-class-name="data-table-header-style"
          :data="tableData"
          style="width: 100%"
          @row-click="showInfoStatus"
          @selection-change="selectionChange"
          v-loading="tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-text="拼命加载中"
        >
          <el-table-column label="序号" width="100" type="index"></el-table-column>
          <el-table-column label="违规信息">
            <template slot-scope="scope">
              <delReportInfo :info="scope.row"></delReportInfo>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="处理状态/备注"  width="600">
            <template slot-scope="scope">
              <delStatusInfo :info="scope.row" assignLoginType="HCM" otherType="myReport"></delStatusInfo>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" v-if="scope.row.status == '0'">
              <el-button @click.stop="dellClick(scope.row.id)" type="text" size="small">删 除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <pagination
          v-if="totalPage > 0"
          class="pagination"
          :total="totalPage"
          v-model="pagination"
          @onChange="getCountByBmc"
          style="text-align:right;margin-top:20px;"
        />
        <!-- 提示-->
        <elementHint
          ref="hintCommon"
          :main2="hint.main2"
          :redMain="hint.redMain"
          :main="hint.main"
          @hintConfire="hintConfire"
          @hintShowCancel="hintShowCancel"
        ></elementHint>
        <!--  详情-->
        <rightInfo ref="refRightInfo"></rightInfo>
      </div>
    </section>
  </div>
</template>

<script>
import headerSearch from "../common/headerSearch";

import elementHint from "../../../components/dataTable/elementHint"; //提示
import pagination from "components/pagination/pagination";
import rightInfo from "./rightInfo"; //详情
import { mapState } from "vuex";
import { getLoginType } from "@/libs/until";
import { mapGetters, mapMutations, mapActions } from "vuex";
import delStatusInfo from "../common/delStatusInfo";
import delReportInfo from "../common/delReportInfo";
import { fetchPost } from "@/libs/reqCommon";
export default {
  name: "report",
  data: function() {
    return {
      logintype: getLoginType(),
      shopList: [],
      plateList: [],
      dealState: true, //处理状态搜索框
      totalPage: 0,
      pagination: {
        size: 10,
        current: 1
      },
      hint: {
        main: "你确认要删除违规信息？",
        main2: "删除后信息将",
        redMain: "无法恢复"
      },
      chekTableNum: {
        all: "",
        check: 0
      },
      tableData: [],
      //获取table的参数
      reportPagedata: {
        pageNo: 1,
        pageSize: 10,
        isMe: "yes"
      },
      //需要删除的信息
      delInfo: {
        checkAll: false,
        info: []
      },
      //状态详情
      dealMain: {
        isShow: false,
        reportId: ""
      },
      tableLoading:true
    };
  },
  components: {
    headerSearch,
    pagination,
    elementHint,
    rightInfo,
    delStatusInfo,
    delReportInfo
  },
  mounted() {
    this.getCountByBmc();
  },
  computed: {
    ...mapState({
      creditSearchData: state => state.creditScore.creditSearchData
    }),
    ...mapGetters(["ifMyInformer"])
  },
  methods: {
    ...mapMutations(["getIfMyInformer"]),
    ...mapActions(["getById"]),
    dellClick(id) {
      let data = {
        ids: id,
      };
      fetchPost("hcm/hcmReport/deleteReportExamine", data).then(res => {
        if (res.status == "10000") {
          this.$message({ type: "success", message: "删除成功" });
          this.getCountByBmc();
        } else {
          this.$message({ type: "warning", message: res.message });
        }
      });
    },
    searchTable() {
      this.tableLoading=true
      this.pagination = {
        size: 10,
        current: 1
      };
      this.getCountByBmc();
    },
    async showInfoStatus(row) {
      this.getIfMyInformer(true);
      await this.getById(row.reportid);
      this.$refs.refRightInfo.ifshow = true;
    },
    selectionChange(data) {
      this.delInfo.info = data; //需要删除的行
      this.chekTableNum.check = data.length;
      //存储是否全选
      if (this.delInfo.info.length === this.tableData.length) {
        this.delInfo.checkAll = true;
      } else {
        this.delInfo.checkAll = false;
      }
    },
    getIds() {
      let ids = [];
      for (let item of this.delInfo.info) {
        ids.push(item.id);
      }
      ids = ids.join(",");
      this.dataIds = ids;
      return ids;
    },
    hintConfire() {
      this.$refs.hintCommon.closeifsee();
      //确认删除
      let data = {};
      if (this.delInfo.checkAll) {
        //  全选
        data.ids = "checkAll";
        data.starttime = this.reportPagedata.starttime;
        data.endtime = this.reportPagedata.endtime;
        if (this.reportPagedata.platform)
          data.platform = this.reportPagedata.platform;
        if (this.reportPagedata.shopname)
          data.shopname = this.reportPagedata.shopname;
        if (this.reportPagedata.reportid)
          data.reportid = this.reportPagedata.reportid;
      } else {
        //删除
        data.ids = this.getIds();
      }
      fetch({
        url: "hcm/hcmReport/Delete",
        method: "post",
        data: data
      }).then(res => {
        if (res.status == "10000") {
          this.$message({ type: "success", message: "删除成功" });
          this.getCountByBmc();
        } else {
          this.$message({ type: "warning", message: res.message });
        }
      });
    },
    hintShowCancel() {
      this.$refs.hintCommon.ifsee();
    },
    statusTabale() {
      this.getCountByBmc();
    },
    deleteBatches() {
      //批量删除
      if (this.delInfo.info.length == 0)
        this.$message({ type: "warning", message: "没有选择的行" });
      else this.$refs.hintCommon.ifsee(); //弹窗显示
    },
    treatment() {
      //批量违规处理
      if (this.delInfo.info.length == 0)
        this.$message({ type: "warning", message: "没有选择的行" });
      else this.illegalProcessing = true;
    },
    handleSizeChange(val) {
      //每页
      this.reportPagedata.pageSize = val;
      this.getCountByBmc();
    },
    handleCurrentChange(val) {
      //当前页
      this.reportPagedata.pageNo = val;
      this.getCountByBmc();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getCountByBmc() {
      //  type 1授权   0全部
      //获取列表
      let pageNo = this.pagination.current;
      let pageSize = this.pagination.size;
      this.tableLoading=true

      fetch({
        url: "hcm/hcmReport/getReportPage",
        method: "get",
        params: {
          type: 0,
          ...this.creditSearchData,
          isMe: "yes",
          pageNo,
          pageSize
        }
      }).then(res => {
        this.tableLoading=false
        if (res.status == "10000") {
          res.data.content.map(item => {
            if (!item.status && item.type === 2 && item.result) {
              item.status = 12;
            } else if (!item.status && item.type === 2 && !item.result) {
              item.status = 11;
            } else if (!item.status && !item.type) {
              item.status = 0;
            }
          });
          this.tableData = res.data.content;
          this.totalPage = res.data.totalElements;
        }
      }).catch(()=>{
         this.tableLoading=false
      })
    }
  }
};
</script>

<style lang="scss">
@import "src/style/tableCommon";
#reportRecord {
  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .deal_state_icon {
    display: flex;
    align-items: center;
  }
  .deal_state_icon i,
  .await_icon {
    font-size: 14px;
    margin-right: 5px;
    width: 13px;
    height: 13px;
  }
  .el-icon-success {
    color: #3fb838;
  }
  .el-icon-error {
    color: #f5222d;
  }
  .header_nav {
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    border-bottom: 1px solid #e1e1e1;
    margin-bottom: 12px;
    & > div {
      margin-right: 50px;
      padding-bottom: 10px;
      border-bottom: 2px solid #fff;
      height: 100%;
    }
    & > div:hover,
    .navHover {
      color: #108cee;
      border-bottom: 2px solid #108cee;
      cursor: pointer;
    }
  }
  .data-table-header-style th {
    background: #f3f7ff !important;
    color: #262626;
  }
  .edit_icon {
    vertical-align: middle;
  }
  .status_info_info {
    color: #666;
  }
  .ellipsis_row {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 70%;
  }
  .cricle {
    width: 6px;
    height: 6px;
    background: #faad14;
    border-radius: 50%;
    display: inline-block;
  }
}
</style>
